import { Box, Button, Grid, Link, Typography } from "@mui/material";
import { useForm, FormProvider, SubmitHandler, FieldValues } from "react-hook-form"
import { useApp } from "../../Contexts/AppProvider";
import { RenderQuestion } from "../../Component";
import { splitList } from "../../utils";
import { IQuestion } from "../../interfaces";

export default function Registration() {
  const {questions, disabledButtons, activeStep, onSetStep, onSubmitRegister} = useApp();
  const questionsListSplit:  IQuestion[][] = splitList(questions as IQuestion[], 2);

  const methods = useForm();

  const onSubmit: SubmitHandler<FieldValues> = async (values) => {
    onSubmitRegister(values, methods);
  }

  const onErrorSubmit = (values: any) => {
    console.log(values);
  }

  return questions && activeStep ? (
    <FormProvider {...methods}>
    <Box
      component="form"
      onSubmit={methods.handleSubmit(onSubmit, onErrorSubmit)}
      autoComplete="off"
      noValidate>
      <Grid container sx={{mt: 0, mb: 4}} spacing={4}>
        {questionsListSplit.map((_, i) => (
          <Grid key={`${i}-questions-grid`} item xl={6} lg={6} md={6} xs={12}>
            {questionsListSplit[i].map((props) => <RenderQuestion key={`${i}-questions-grid-${props.index}-question`} {...props} />)}
          </Grid>
        ))}
        
        <Grid item xl={6} lg={6} md={6} xs={12} />
        <Grid item xl={6} lg={6} md={6} xs={12}>
          <Typography style={{fontSize:19}}>
            Ao clicar em <strong>"Próximo"</strong> você concorda com nossos <Link href='https://mkt.n2app.com.br/termodeusoeprivacidadelgpdn2' target="_blank"><strong>Termos de uso e Privacidade LGPD</strong></Link>
          </Typography>
        </Grid>
  
        
    
      </Grid>
      
      <Box sx={{display: 'flex', justifyContent: 'space-between' }}>  
        <Button disabled={disabledButtons} variant="contained" onClick={() => onSetStep(activeStep-1)}>
          Anterior
        </Button>
      
        <Button id='btnNext' disabled={disabledButtons} type="submit" variant="contained">
          Próximo
        </Button>  
      </Box>
    </Box>
    </FormProvider>
  ) : <></>;
}
